import styled from '@emotion/styled';

export const DashboardItemIcon = styled.div`
  font-size: 3.125rem;
  width: 6.25rem;
  height: 6.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #008995;
  border: 0.1875rem solid #008995;
`;
export const DashboardItemTitle = styled.h4`
  font-weight: normal;
  margin: 0;
  a {
    text-decoration: none;
    color: #008995;
    &:hover {
      color: #c57006;
      text-decoration: underline;
    }
  }
`;

export const DashboardCard = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  margin-bottom: 1rem;
  text-decoration: none;
  color: #008995;
  border: 0.1875rem solid #008995;
  transition: background 0.2s;
  box-shadow: 0.125rem 0.4375rem 1.125rem -0.6875rem rgba(0, 0, 0, 0.8);
  &:hover {
    cursor: pointer;
    color: #f89820;
    border-color: #f89820;
    text-decoration: none;
  }
`;

export const DashboardCardIcon = styled.i`
  font-size: 3.125rem;
`;
export const DashboardContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  box-shadow: 0.125rem 0.4375rem 1.125rem -0.6875rem rgba(0, 0, 0, 0.8);
  border-radius: 0;
  a{ text-decoration: none; color: #008995; &:hover { color: #f89820; text-decoration: underline; } }
`;

export const DashboardItemCenter = styled.div`
  text-align: center;
`;

export const DashboardItemCenterInfo = styled.div`
  text-transform: italic;
  color: #000000
`;
